import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../hooks/use-http";

import moment from "moment";

import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { useAuth } from "../../../store/auth";

const InventoryClosingForm = (props) => {
  const { warehouse } = useAuth();
  const [loading, setLoading] = useState(false);
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);

  const [warehouseId, setWarehouseId] = useState(0);

  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getEmp } = useHttp();
  const getAllEmp = () => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  };

  useEffect(() => {
    getAllEmp();
    console.log(warehouse);
  }, []);

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);

  const { sendRequest: getStockForClosing } = useHttp();

  const getData = () => {
    getStockForClosing(
      {
        url: `/api/getAllWarehouseStockForStockClosing/?warehouseId=${warehouseId}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log(data);
        setData(data.warehouseStock);
      }
    );
  };

  useEffect(() => {
    getData();
  }, [warehouseId]);

  const { sendRequest: postStockForClosing } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    if (data && data.length === 0) {
      toast.error("Stock not Available");
      return;
    }

    setLoading(true);

    const input =
      data &&
      data.map((item) => ({
        ...item,
        warehouseId: warehouseId,
        employeeId: employeeId,
        stockDailyClosingDate: moment(currentDate).format("DD/MM/YYYY"),
        orgId: localStorage.getItem("orgId"),
        status: 1,
        createdBy: localStorage.getItem("id"),
        serviceId: props.sId,
      }));
    console.log(input);

    postStockForClosing(
      {
        url: "/api/stockDailyClosing/",
        method: "POST",
        body: input,
      },
      (data) => {
        console.log(data);
        toast.success("closing Stock Added Successfully");
        setWarehouseId("");
        setEmployeeId("");
        setData("");
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <form onSubmit={submitHandler}>
          <section className="content">
            <div className="container-fluid">
              <div className="row mx-2">
                <div className="col-md-9">
                  <br />
                  <label className="">Daily Closing Stock </label>
                </div>
                <div className="col-md-3">
                  <br />
                  <div className="text-right">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>{" "}
              </div>

              <div className="row mt-3 mx-3">
                <div className="col-md-2">
                  <div className="form-group">
                    {" "}
                    <label htmlFor={"date"}>{"Date"}</label>
                    <input
                      type={"date"}
                      id={"date"}
                      required
                      readOnly
                      className="form-control"
                      value={currentDate}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor={"executive_officer"}>
                    {"Assign Supervisor"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    required
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.empId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label htmlFor={"warehouse_name"}>
                    {"Warehouse Wise Stock"}
                  </label>

                  <select
                    id="warehouse_name"
                    className="form-control"
                    ref={(el) => (frmRef.current["warehouse_name"] = el)}
                    required
                    value={warehouseId}
                    onChange={(e) => {
                      setWarehouseId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {warehouse &&
                      warehouse.map((x) => (
                        <option key={x.id} value={x.id}>
                          {x.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <hr />
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body" style={{ padding: "1.4rem" }}>
                      <table className="table table-bordered  text-center table-sm">
                        <thead>
                          <tr className="table-header">
                            <th> Item Id </th>
                            <th>Product Name</th>
                            <th> Product Item Sub Type </th>
                            <th>Product Item Type </th>
                            <th>Item Quantity </th>
                            <th>Unit</th>
                          </tr>
                        </thead>

                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td> {itm.itemId} </td>

                                <td> {itm.productName} </td>

                                <td>{itm.productSubTypeName}</td>

                                <td> {itm.productTypeName} </td>
                                <td> {itm.stockQuantity} </td>
                                <td> {itm.unitAbbreviation} </td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>

                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="">
            <div className="text-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default InventoryClosingForm;
